// 移除过时的polyfill，使用现代的core-js
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import './assets/antd-image-preview-fix.css'

import i18n from './i18n'
import './permission'
import './icons'

import axios from 'axios'
Vue.prototype.axios = axios

Vue.use(Antd)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
